const loaded = (el) => {
    // Find all images in the element
    const images = el.querySelectorAll('img');
    let loadedImagesCount = 0;

    // Function to check if all images have loaded
    const checkAllImagesLoaded = () => {
        if (loadedImagesCount === images.length) {
            images.forEach(function (image) {
                el.classList.add('loaded');
            });
        }
    }

    images.forEach(function (image) {
        if (image.complete) {
            loadedImagesCount++;
            checkAllImagesLoaded();
        } else {
            image.addEventListener('load', function () {
                loadedImagesCount++;
                checkAllImagesLoaded();
            });
        }
    });
};

export default loaded;

